import proj4 from 'proj4';
import Crs from './Crs';

// Definice EPSG:5514 (S-JTSK / Krovak East North)
proj4.defs(
    Crs.S_JTSK,
    '+proj=krovak +lat_0=49.5 +lon_0=24.83333333333333 +alpha=30.28813972222222 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=570.8,85.7,462.8,4.998,1.587,5.261,3.56 +units=m +no_defs',
);

/**
 * Dolní hranice X souřadnic pro lokální oblast (v našem případě ČR).
 * @type {number}
 */
const LOCAL_X_MIN: number = -910000;

/**
 * Horní hranice X souřadnic pro lokální oblast (v našem případě ČR).
 * @type {number}
 */
const LOCAL_X_MAX: number = -420000;

/**
 * Dolní hranice Y souřadnic pro lokální oblast (v našem případě ČR).
 * @type {number}
 */
const LOCAL_Y_MIN: number = -1220000;

/**
 * Horní hranice Y souřadnic pro lokální oblast (v našem případě ČR).
 * @type {number}
 */
const LOCAL_Y_MAX: number = -930000;

/**
 * Otestuje, zda dvojice představuje XY souřadnice
 * pro lokální oblast (v našem případě ČR).
 *
 * @param {ol.Coordinate} coord - souřadnice
 * @return {boolean} zda jde o XY
 */
export const isLocalXY = (coord: [number, number]): boolean => {
    return coord[0] >= LOCAL_X_MIN && coord[0] <= LOCAL_X_MAX && coord[1] >= LOCAL_Y_MIN && coord[1] <= LOCAL_Y_MAX;
};

/**
 * Převede GPS souřadnice na XY souřadnice.
 *
 * @param coord - GPS souřadnice
 * @return XY souřadnice
 */
export const lonLatToXy = (coord: [number, number]): [number, number] => {
    return proj4(Crs.WGS_84, Crs.S_JTSK, coord) as [number, number];
};

/**
 * Vytvoří bodovou GeoJSON feature pro zadané souřadnice.
 * @param coordinates souřadnice bodu
 */
export const createCoordinateFeature = (
    coordinates: number[],
): {
    type: 'Feature';
    id: string;
    geometry: {
        type: 'Point';
        coordinates: number[];
    };
    properties: {};
} => {
    return {
        type: 'Feature',
        id: 'coordinate-result',
        geometry: {
            type: 'Point',
            coordinates: coordinates,
        },
        properties: {},
    };
};

// Regulární výraz pro rozpoznání souřadnic
const numberRegExp = '-?\\s*[.\\d]*\\d+[.\\d]*'; // Musí obsahovat minimálně jednu číslici.
const separatorRegExp = '[^-.\\d]*'; // Vše kromě pomlčky, tečky a číslic.
const coordsRegExp = new RegExp(separatorRegExp + '(' + numberRegExp + ')' + separatorRegExp + '(' + numberRegExp + ')' + separatorRegExp);

export function getSearchCoordinates(text: string) {
    const match = text.match(coordsRegExp);
    if (match?.length === 3) {
        const x = Number.parseFloat(match[1].replace(/\s+/g, '')); // Ořezání volitelných mezer za pomlčkou
        const y = Number.parseFloat(match[2].replace(/\s+/g, ''));
        let xy: [number, number] = [x, y];

        if (Number.isFinite(x) && Number.isFinite(y)) {
            if (isLocalXY(xy)) {
                return xy;
            }
            xy = lonLatToXy([y, x]); // GPS zadává uživatel v opačném pořadí.
            if (isLocalXY(xy)) {
                return xy;
            }
        }
    }
    return null;
}
